import React from 'react';
import { Folder } from 'lucide-react';
export function SolutionSection() {
  const cases = [{
    id: '01',
    title: 'Caso #1: Infidelidad Digital'
  }, {
    id: '02',
    title: 'Caso #2: La Carga Mental'
  }, {
    id: '03',
    title: 'Caso #3: El Conflicto de Suegras'
  }, {
    id: '04',
    title: 'Caso #4: La Intimidad Perdida'
  }, {
    id: '05',
    title: 'Caso #5: Secretos de Dinero'
  }];
  return <section className="py-20 bg-noir-bg border-b border-noir-border relative overflow-hidden" data-id="element-182">
      {/* Background forensic lines */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5 pointer-events-none" data-id="element-183">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-184">
          <defs data-id="element-185">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-186">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#F2F2F2" strokeWidth="1" data-id="element-187" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-188" />
        </svg>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative z-10" data-id="element-189">
        <div className="mb-12" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-mono font-bold text-noir-text mb-4 uppercase" data-id="element-191">
            La Solución: <span className="text-noir-alert" data-id="element-192">Los 5 Casos</span>
          </h2>
          <p className="text-noir-muted max-w-2xl" data-id="element-193">
            El Dossier del Detective incluye relatos basados en conflictos
            reales. Fichas de evidencia y preguntas guiadas para desmenuzar el
            comportamiento de los "sujetos" y aplicar la solución a su propia
            relación.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-194">
          {cases.map((c, index) => <div key={index} className="bg-noir-card border border-noir-border p-6 rounded-sm relative group hover:bg-[#141414] transition-colors" data-id="element-195">
              <div className="flex justify-between items-start mb-8" data-id="element-196">
                <Folder className="w-8 h-8 text-noir-muted group-hover:text-noir-text transition-colors" data-id="element-197" />
                <span className="bg-noir-alert text-white text-[10px] font-bold px-2 py-1 rounded-sm tracking-widest uppercase" data-id="element-198">
                  Confidential
                </span>
              </div>
              <div className="mt-auto" data-id="element-199">
                <div className="text-xs text-noir-muted font-mono mb-1" data-id="element-200">
                  FILE: {c.id}
                </div>
                <h3 className="text-lg font-mono font-bold text-noir-text uppercase" data-id="element-201">
                  {c.title}
                </h3>
              </div>
            </div>)}

          {/* Bonus Card */}
          <div className="bg-noir-crimson/20 border border-noir-alert/50 p-6 rounded-sm relative group flex flex-col justify-between" data-id="element-202">
            <div className="flex justify-between items-start mb-8" data-id="element-203">
              <Folder className="w-8 h-8 text-noir-alert" data-id="element-204" />
              <span className="bg-noir-alert text-white text-[10px] font-bold px-2 py-1 rounded-sm tracking-widest uppercase" data-id="element-205">
                Bonus
              </span>
            </div>
            <div data-id="element-206">
              <div className="text-xs text-noir-alert font-mono mb-1" data-id="element-207">
                FILE: EX
              </div>
              <h3 className="text-lg font-mono font-bold text-noir-text uppercase" data-id="element-208">
                El Veredicto
              </h3>
              <p className="text-xs text-noir-muted mt-2" data-id="element-209">
                Guía de premios y recompensas románticas para el ganador.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}